(function () {
  'use strict';

  var d = window.lfProductData;
  if (!d) return;

  var frames   = d.frames;
  var variants = d.variants;
  var varMedia = d.variantMedia;
  var symbol   = d.symbol;

  // Seed the initial leaf from the pre-selected card so state.leaf carries the
  // real (localized) variant option value — e.g. "Lorbeer" on the German store —
  // instead of a hardcoded English string that wouldn't match the variant.
  var selLeafEl = document.querySelector('#lfLeafOpts .lf-opt.sel');
  var state = {
    leaf:  selLeafEl ? selLeafEl.dataset.leaf : 'Laurel',
    frame: 'gold-classic'
  };
  var currentVariant = null;   // the Shopify variant matching the current leaf + frame

  /* ── DOM refs ──────────────────────────────────────── */
  var productImg   = document.getElementById('lfProductImg');
  var priceNum     = document.getElementById('lfPriceNum');
  var leafPick     = document.getElementById('lfLeafPick');
  var framePick    = document.getElementById('lfFramePick');
  var atcPrice     = document.getElementById('lfAtcPrice');
  var stickyPrice  = document.getElementById('lfStickyPrice');
  var stickyMeta   = document.getElementById('lfStickyMeta');
  var variantId    = document.getElementById('lfVariantId');
  var thumbs       = document.getElementById('lfThumbs');
  var fo           = document.getElementById('lfFrameOpts');

  /* ── Map each frame → a representative product image + its live price ── */
  var frameNames = {};                                   // frame display name → frame key
  Object.keys(frames).forEach(function (k) { frameNames[frames[k].name] = k; });
  var frameImg = {};                                     // frame name → {src, thumb, alt}
  var framePrice = {};                                   // frame name → variant price (cents)
  variants.forEach(function (v) {
    var m = varMedia[String(v.id)];
    [v.option1, v.option2, v.option3].forEach(function (opt) {
      if (!opt || !frameNames.hasOwnProperty(opt)) return;
      if (m && !frameImg[opt]) frameImg[opt] = m;             // first photo seen for this frame
      if (framePrice[opt] == null) framePrice[opt] = v.price; // real Shopify price (cents)
    });
  });

  /* ── Money ──────────────────────────────────────────────
     Variant prices are integer cents already in the active presentment
     currency, so a currency switch flows through automatically. Show whole
     units only (drops the .90 the prices carry). ── */
  function wholeAmount(cents) { return Math.floor(cents / 100); }
  function frameAmount(f) {
    var cents = framePrice[f.name];
    return cents != null ? wholeAmount(cents) : f.price;  // f.price = fallback only
  }

  /* ── Build compact frame option cards ──────────────── */
  fo.innerHTML = Object.entries(frames).map(function (entry) {
    var k = entry[0], f = entry[1];
    var img = frameImg[f.name];
    var thumb = img
      ? '<span class="lf-fthumb"><img src="' + img.thumb + '" alt="" loading="lazy"></span>'
      : '<span class="lf-fthumb"><span class="lf-fframe" style="--fc:' + f.col + '"></span></span>';
    return '<div class="lf-frame-opt' + (k === 'gold-classic' ? ' sel' : '') + '"' +
      ' data-frame="' + k + '" role="radio" aria-checked="' + (k === 'gold-classic') + '" tabindex="0">' +
      (f.badge ? '<span class="lf-badge-best">' + f.badge + '</span>' : '') +
      '<span class="check" aria-hidden="true">✓</span>' +
      thumb +
      '<span class="lf-finfo">' +
        '<span class="lf-fname">' + f.name + (f.float ? ' <span class="tag">360°</span>' : '') + '</span>' +
        '<span class="lf-fmeta">' + f.size + ' · ' + f.mat + '</span>' +
      '</span>' +
      '<span class="lf-fprice">' + symbol + frameAmount(f) + '</span>' +
    '</div>';
  }).join('');

  /* ── Gallery: show a product image ──────────────────── */
  function showPhoto(src, alt) {
    if (!src || !productImg) return;
    productImg.src = src;
    productImg.alt = alt || '';
    productImg.style.display = 'block';
    setActiveThumbByMediaSrc(src);
  }

  function setActiveThumbByMediaSrc(src) {
    document.querySelectorAll('#lfThumbs .lf-thumb').forEach(function (t) {
      t.classList.toggle('act', t.dataset.mediaSrc === src);
    });
  }

  /* ── Find the Shopify variant for the current leaf + frame ── */
  function findVariant() {
    var fname = frames[state.frame].name;
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return opts.indexOf(state.leaf) > -1 && opts.indexOf(fname) > -1;
    }) || null;
  }

  /* ── Swap the gallery image to match the selected variant ── */
  function swapGalleryImage(match) {
    var specific = match ? varMedia[String(match.id)] : null;  // exact leaf+frame image
    var byFrame  = frameImg[frames[state.frame].name];         // representative frame image
    if (specific) {
      showPhoto(specific.src, specific.alt);
    } else if (byFrame) {
      showPhoto(byFrame.src, byFrame.alt);
    }
    // else: keep the current (first real) photo in view
  }

  /* ── Price for the current selection — the matched variant's real price shown
        IN FULL (incl. cents) for the main price, ATC button and sticky bar.
        Falls back to the frame price only if no variant matches. ── */
  function formatMoney(cents) {
    var amount = cents / 100;
    return amount % 1 === 0 ? String(amount) : amount.toFixed(2);
  }
  function priceLabel() {
    return currentVariant ? formatMoney(currentVariant.price) : String(frames[state.frame].price);
  }

  /* ── Update all UI labels/prices ───────────────────── */
  function render() {
    var f = frames[state.frame];

    currentVariant = findVariant();
    if (currentVariant && variantId) variantId.value = currentVariant.id;

    var price = priceLabel();
    if (priceNum)  priceNum.textContent  = price;
    if (leafPick)  leafPick.textContent  = state.leaf;
    if (framePick) framePick.textContent = f.name;
    if (atcPrice)  atcPrice.textContent  = symbol + price;
    if (stickyPrice && stickyPrice.firstChild) stickyPrice.firstChild.textContent = symbol + price;
    if (stickyMeta)  stickyMeta.textContent = state.leaf + ' · ' + f.name;

    swapGalleryImage(currentVariant);
  }

  /* ── Leaf selection ─────────────────────────────────── */
  document.getElementById('lfLeafOpts').addEventListener('click', function (e) {
    var o = e.target.closest('.lf-opt'); if (!o) return;
    document.querySelectorAll('#lfLeafOpts .lf-opt').forEach(function (x) {
      x.classList.remove('sel'); x.setAttribute('aria-checked', 'false');
    });
    o.classList.add('sel'); o.setAttribute('aria-checked', 'true');
    state.leaf = o.dataset.leaf;
    render();
  });
  document.getElementById('lfLeafOpts').addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); e.target.click(); }
  });

  /* ── Frame selection ────────────────────────────────── */
  fo.addEventListener('click', function (e) {
    var o = e.target.closest('.lf-frame-opt'); if (!o) return;
    document.querySelectorAll('#lfFrameOpts .lf-frame-opt').forEach(function (x) {
      x.classList.remove('sel'); x.setAttribute('aria-checked', 'false');
    });
    o.classList.add('sel'); o.setAttribute('aria-checked', 'true');
    state.frame = o.dataset.frame;
    render();
  });
  fo.addEventListener('keydown', function (e) {
    var o = e.target.closest('.lf-frame-opt');
    if (o && (e.key === ' ' || e.key === 'Enter')) { e.preventDefault(); o.click(); }
  });

  /* ── Thumbnail strip clicks ─────────────────────────── */
  thumbs.addEventListener('click', function (e) {
    var t = e.target.closest('.lf-thumb'); if (!t) return;
    if (t.dataset.mediaSrc) showPhoto(t.dataset.mediaSrc, t.dataset.mediaAlt);
  });
  thumbs.addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); e.target.click(); }
  });

  /* ── Add to cart via AJAX → open the cart drawer (no page redirect) ── */
  var atcBtn    = document.getElementById('lfAtc');
  var stickyAtc = document.getElementById('lfStickyAtc');
  var form      = document.getElementById('lf-product-form');

  // Brief "✓ Added" confirmation on the main ATC button, then restore it.
  function flashAdded() {
    if (!atcBtn) return;
    atcBtn.classList.add('done');
    atcBtn.textContent = '✓ ' + d.addedLabel;
    setTimeout(function () {
      atcBtn.classList.remove('done');
      atcBtn.innerHTML = d.atcLabel + ' → <span id="lfAtcPrice">' + symbol + priceLabel() + '</span>';
      atcPrice = document.getElementById('lfAtcPrice');
    }, 1600);
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      // The cart drawer (or notification) is what we open instead of redirecting.
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart) return;            // cart type = page → let Shopify redirect normally

      e.preventDefault();
      if (atcBtn && atcBtn.getAttribute('aria-disabled') === 'true') return;
      if (atcBtn) atcBtn.setAttribute('aria-disabled', 'true');

      // Mirror Dawn's product-form AJAX add so the drawer's section render works.
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(form);
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {                 // e.g. sold out / invalid variant
            console.warn('[leafsy] add to cart failed:', response.description || response.message);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'leafsy-product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }
          cart.renderContents(response);         // re-render drawer sections + open it
          flashAdded();
        })
        .catch(function (err) { console.error(err); })
        .finally(function () {
          if (atcBtn) atcBtn.removeAttribute('aria-disabled');
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    });
  }

  /* ── Sticky ATC just submits the same form (handled above) ── */
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function () {
      if (form) form.requestSubmit();
    });
  }

  /* Reveal the sticky bar only AFTER the main ATC is scrolled past (above the
     viewport), and tuck it away again once the footer comes into view, so it
     never covers the hero or the footer. */
  var stickyBar = document.getElementById('lfStickyBar');
  if (atcBtn && stickyBar && 'IntersectionObserver' in window) {
    var passedAtc = false;
    var atEnd = false;
    function updateStickyBar() {
      stickyBar.classList.toggle('show', passedAtc && !atEnd);
    }
    var atcIO = new IntersectionObserver(function (entries) {
      var e = entries[0];
      passedAtc = !e.isIntersecting && e.boundingClientRect.top < 0;
      updateStickyBar();
    }, { threshold: 0 });
    atcIO.observe(atcBtn);

    var footer = document.querySelector('.footer') || document.querySelector('footer');
    if (footer) {
      var footIO = new IntersectionObserver(function (entries) {
        atEnd = entries[0].isIntersecting;
        updateStickyBar();
      }, { threshold: 0 });
      footIO.observe(footer);
    }
  }

  /* ── Init ───────────────────────────────────────────── */
  render();
})();
